export enum Permission {
  ConnectOrdersView = 'connect_orders.view',
  ConnectOrdersModify = 'connect_orders.modify',
}
